const HOTJAR_SITE_ID = 2567154;

const initHotjar = () => {
    const hotjarStatus = process.env.VUE_APP_HOTJAR_TRACKING_ENABLED || '';
    const isTrackingEnabled = hotjarStatus === 'true';

    if (!isTrackingEnabled) {
        // eslint-disable-next-line no-console
        console.log('Hotjar: Disabled (Development Mode)');
        return;
    }

    /* eslint-disable no-param-reassign, no-underscore-dangle, prefer-rest-params, no-console */
    (function (h, o, t, j, a, r) {
        h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments); };
        h._hjSettings = { hjid: HOTJAR_SITE_ID, hjsv: 6 };
        a = o.getElementsByTagName('head')[0];
        r = o.createElement('script'); r.async = 1;
        r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
        a.appendChild(r);
    }(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv='));
    /* eslint-enable no-param-reassign, no-underscore-dangle, prefer-rest-params, no-console */
};

export { initHotjar as default };
